import { StoreModelStateProps } from '@smx-ui-model/store-model-slice';
import modelReducer from '@smx-ui-model/store-model-slice';

import { InspectorStateProps } from './slices/inspector-slice';
import inspectorReducer from './slices/inspector-slice';
import { ISpinnerState } from './slices/spinner-slice';
import spinnerReducer from './slices/spinner-slice';

export const inspectorReducers = {
    spinner: spinnerReducer,
    inspector: inspectorReducer,
    model: modelReducer,
};

export interface InspectorReduxState {
    inspector: InspectorStateProps;
    spinner: ISpinnerState;
    model: StoreModelStateProps;
}
